import * as React from "react";
import { Intent, NumericInput } from "@focus/focusUI";
import { DATE_FORMATS } from "@focus/formComponents/lib/interfaces";
import { DateTime } from "luxon";
import { unix2mjd, mjd2unix } from "../helpers/timeParser";
import { EpochWithClear } from "@focus/formComponents";
export class GrafosDialogInput extends React.Component {
    constructor() {
        super(...arguments);
        this.onChangeHandler = (value) => {
            if (value === null) {
                return this.props.onChange(value);
            }
            const finalValue = DateTime.fromFormat(value, "yyyy/MM/dd-hh:mm:ss.SSS", {
                zone: "utc",
            }).toMillis();
            if (isNaN(finalValue)) {
                return this.props.onChange(unix2mjd(DateTime.fromFormat("2000/01/01-00:00:00.000", "yyyy/MM/dd-hh:mm:ss.SSS", {
                    zone: "utc",
                }).toMillis()));
            }
            return this.props.onChange(unix2mjd(finalValue));
        };
    }
    render() {
        return this.props.axis.mode === "Date" ? (React.createElement(EpochWithClear, { format: DATE_FORMATS.STD_ABS, dateTime: this.props.value === null
                ? this.props.value
                : DateTime.fromMillis(mjd2unix(this.props.value), {
                    zone: "utc",
                }).toFormat("yyyy/MM/dd-HH:mm:ss.SSS"), onChange: this.onChangeHandler, isDisabled: false, isHidden: false, isReadOnly: false, schemaDefaultDateTime: null })) : (React.createElement(NumericInput, { role: "focus-numericDateInput", intent: Intent.PRIMARY, value: this.props.value, onValueChange: (_, val) => this.props.onChange(val) }));
    }
}
//# sourceMappingURL=GrafosDialogInput.js.map